export const getReferralFlowId = state => state.referralFlows.referralFlow.id;
export const getReferralFlowEmail = state => state.referralFlows.referralFlow.email;
export const getReferralFlowData = state => state.referralFlows.referralFlow;
export const referralFlowIsFetching = state => state.referralFlows.loading;